module.exports = "<div id=\"chartdiv\" class=\"market_depth_container\"></div>"